import { PLATFORM, autoinject } from 'aurelia-framework';
import { PubSub } from 'lib/event/PubSub';
import { EventAggregator } from 'aurelia-event-aggregator';
import { RouterConfiguration } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';

@autoinject
export class StatisticsDashboardView {
  private serviceTabName: string = `${this.t.tr('general.service')}`;
  private salesTabName: string = `${this.t.tr('general.nets_sales')}`;
  // private productionTabName: string = `${this.t.tr('general.production')}`;

  constructor(protected pubsub: PubSub, protected eventAggregator: EventAggregator, private t: I18N) {
    pubsub.sub('i18n:locale:changed', () => this.onLocaleChanged());
  }

  private onLocaleChanged() {
    this.serviceTabName = `${this.t.tr('general.service')}`;
    this.salesTabName = `${this.t.tr('general.nets_sales')}`;
    // this.productionTabName = `${this.t.tr('general.production')}`;
  }

  detached() {
    this.pubsub.unsub();
  }

  protected configureRouter(config: RouterConfiguration) {
    return config.map([
      {
        route: ['', 'nets-sales'],
        name: 'nets-sales',
        moduleId: PLATFORM.moduleName('./tab-nets-sales'),
        tabindex: 0,
        nav: true,
        entityShortName: 'nets-sales',
        title: this.salesTabName,
      },
      {
        route: ['nets-service'],
        name: 'nets-service',
        moduleId: PLATFORM.moduleName('./nets-service/tab-nets-service'),
        tabindex: 1,
        nav: true,
        entityShortName: 'nets-service',
        title: this.serviceTabName,
      },
      // {
      //   route: ['nets-production'],
      //   name: 'nets-production',
      //   moduleId: PLATFORM.moduleName('./nets-production/tab-nets-production'),
      //   tabindex: 2,
      //   nav: true,
      //   entityShortName: 'nets-production',
      //   title: this.productionTabName,
      // },
    ]);
  }
}
